// @flow

export const STUDENT_RESULT_TYPE = 'student_profile';
export const DRIVER_RESULT_TYPE = 'driver_profile';
export const MONITOR_RESULT_TYPE = 'monitor_profile';
export const PARENT_RESULT_TYPE = 'parent_profile';
export const GATE_RESULT_TYPE = 'gate';



// WEBPACK FOOTER //
// ./src/scripts/components/UserSearchResult/types.js